import { render, staticRenderFns } from "./SettingsCreateVersion.vue?vue&type=template&id=794cde75&scoped=true"
import script from "./SettingsCreateVersion.vue?vue&type=script&lang=js"
export * from "./SettingsCreateVersion.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateVersion.vue?vue&type=style&index=0&id=794cde75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794cde75",
  null
  
)

export default component.exports